<template>
  <div v-if="$ability.can('write', 'Sale')">
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <AppSkeletonCardForm v-if="loadingFetch" :rows="6" />
        <SaleEditReviewForm
          v-else
          @delete="onDelete()"
          @cancel="onUpdateStatus({ statusId: 3 })"
          @activate="onUpdateStatus({ statusId: 2 })"
          @redo="onRedoSale()"
          @prev-page="prevPage()"
          @save="save()"
        ></SaleEditReviewForm>
      </div>
      <div class="p-col-12 p-md-6">
        <AppSkeletonCardForm v-if="loadingFetch" :rows="10" />
        <SaleEditReviewBuyer v-else></SaleEditReviewBuyer>
      </div>
      <div class="p-col-12">
        <AppSkeletonCardTable v-if="loadingFetch"></AppSkeletonCardTable>
        <SaleBovineReviewCard
          v-else
          :saleBovines="bovines"
        ></SaleBovineReviewCard>
      </div>
    </div>
    <div class="p-col-12">
      <div class="p-grid p-jc-end p-mt-2">
        <div style="padding-right: 8px">
          <Button
            label="Voltar"
            class="p-button-outlined p-mr-2"
            @click="prevPage()"
          />
          <AppButton label="Salvar" @click="save()" :loading="loadingSave" />
        </div>
      </div>
    </div>
    <SaleReceipt
      v-if="$route.params.id"
      :saleId="$route.params.id"
    ></SaleReceipt>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import SaleEditReviewBuyer from './SaleEditReviewBuyer';
import SaleEditReviewForm from './SaleEditReviewForm';
import SaleBovineReviewCard from './components/SaleBovineReviewCard';
import SaleReceipt from './components/SaleReceipt.vue';

export default {
  name: 'SaleEditReview',
  components: {
    SaleEditReviewForm,
    SaleEditReviewBuyer,
    SaleBovineReviewCard,
    SaleReceipt,
  },
  computed: {
    ...mapFields('sale', [
      'formData.bovines',
      'formData.buyer',
      'formData.date',
      'formData.statusId',
      'loadingFetch',
      'loadingSave',
    ]),
  },
  emits: ['nextPage', 'prevPage', 'changePage'],
  async created() {
    if (this.$route.params.id) {
      await this.fetchSale(this.$route.params.id);
    }
    if (!this.buyer.name) {
      this.$emit('change-page', { index: 0 });
    }
  },
  methods: {
    ...mapActions('sale', [
      'create',
      'fetchSale',
      'update',
      'updateStatus',
      'delete',
      'redoSale',
    ]),
    prevPage() {
      if (this.$route.params.id) {
        return this.$router.push({ name: 'sale.list' });
      }
      this.$emit('prev-page', { pageIndex: 3 });
    },
    async save() {
      try {
        this.loadingSave = true;
        if (this.$route.params.id) {
          await this.update();
        } else {
          await this.create();
        }
        this.$router.push({ name: 'sale.list' });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingSave = false;
      }
    },
    async onDelete() {
      try {
        await this.delete();
        this.$router.push({ name: 'sale.list' });
      } catch (error) {
        console.error(error);
      }
    },
    async onUpdateStatus({ statusId }) {
      try {
        await this.updateStatus(statusId);
        this.$router.push({ name: 'sale.list' });
      } catch (error) {
        console.error(error);
      }
    },
    async onRedoSale() {
      if (this.statusId !== 3) {
        await this.updateStatus(3);
      }
      this.redoSale();
      return this.$router.push({ name: 'sale.create' });
    },
  },
};
</script>

<style scoped>
</style>
